export const BASE_PATH = "https://backoffice.tonivivescabaleiro.com";
